module.exports = __webpack_public_path__ + "img/alimenticia.24d57b37.png";